// extracted by mini-css-extract-plugin
module.exports = {"chart":"Overview_chart__syaQh","area":"Overview_area__f8MTi","headerIcon":"Overview_headerIcon__1T6x7","fans":"Overview_fans__3czub","icon":"Overview_icon__2BWv-"};